import React from 'react';
import ListaItem from "./lista-item";
class ListaTematica extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        this.props.onChange(event);
    }
    render() {
        const data = this.props.items || [];
        if (data.length > 0) {
            return (
                <div>
                    <ul {...{ className: 'accordion-list' }}>
                        {data.map((item, key) => {
                            return (
                                <li key={key} {...{ className: 'accordion-list__item', key }}>
                                    <ListaItem title={item.name} items={item.child} onChange={this.handleChange} />
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )
        } else {
            return <div></div>;
        }
    }
}
export default ListaTematica;